var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('panelmember',{attrs:{"position":_vm.$route.params.position},on:{"submit":function($event){return _vm.update($event)},"cancel":function($event){return _vm.cancel($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }